import { render, staticRenderFns } from "./AdminChangelogInnerTableCell.vue?vue&type=template&id=0ba72d5e&"
import script from "./AdminChangelogInnerTableCell.vue?vue&type=script&lang=ts&"
export * from "./AdminChangelogInnerTableCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
